/** Sann dersom angitt verdi er et tall. */
export function erTall(verdi: any): verdi is number {
    return (typeof verdi) === 'number'
}

/** Sann dersom angitt verdi IKKE er et tall. */
export function erIkkeTall(verdi: any): boolean {
    return !erTall(verdi);
}

export function begrensTilVerdiMellom(tall: number, min: number, max: number): number {
    return Math.max(Math.min(tall, max), min);
}
